export const QUALTRICS_FORCE_RESPONSE = {
  ON: 'ON',
  OFF: 'OFF',
} as const;

export const QUALTRICS_SURVEY_TYPES = {
  ALWAYS_ON: 'alwaysOn',
  TOUCHPOINT: 'touchpoint',
} as const;

export const QUALTRICS_INVALID_COMMENT_ERROR =
  'Invalid request: Body contains invalid comment.';

export const QUALTRICS_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'MC',
  TEXT_ENTRY: 'TE',
} as const;

export const QUALTRICS_SELECTORS = {
  SINGLE_ANSWER_VERTICAL: 'SAVR',
  SINGLE_ANSWER_HORIZONTAL: 'SAHR',
  MULTIPLE_ANSWER_VERTICAL: 'MAVR',
  MULTIPLE_ANSWER_HORIZONTAL: 'MAHR',
  SINGLE_LINE: 'SL',
  MULTI_LINE: 'ML',
  ESTB: 'ESTB',
  FORM: 'FORM',
} as const;

export const QUALTRICS_SUPPORTED_SELECTORS = new Set(
  Object.values(QUALTRICS_SELECTORS),
);

export const QUALTRICS_HORIZONTAL_SELECTORS = [
  QUALTRICS_SELECTORS.SINGLE_ANSWER_HORIZONTAL,
  QUALTRICS_SELECTORS.MULTIPLE_ANSWER_HORIZONTAL,
] as const;

export const QUALTRICS_MULTI_SELECT_SELECTORS = [
  QUALTRICS_SELECTORS.MULTIPLE_ANSWER_VERTICAL,
  QUALTRICS_SELECTORS.MULTIPLE_ANSWER_HORIZONTAL,
] as const;
